import * as React from 'react';

import * as styles from './footerLink.scss';

type Props = {
    key: any;
    item: any;
}

const FooterLink: React.SFC<Props> = props => {
    return (
        <div className={styles.wrapper}>
            <a className={styles.link}
               href={props.item.link}
               target={props.item.target}
            >
                <span className={styles.icon}>
                    {props.item.icon}
                </span>
                <span className={styles.copy}>{props.item.text}</span>
            </a>
        </div>
    )
}


export default FooterLink;